<template>
  <v-text-field
    v-model="passwordModel"
    v-bind="$attrs"
    :type="isPasswordVisible ? 'text' : 'password'"
    :rules="rules"
    :label="label"
    :placeholder="placeholder"
    :passwordrules="recommendPasswordRules"
    :autocomplete="autocomplete"
    :name="name"
    :counter="counter"
    :aria-autocomplete="autocomplete === 'new-password' ? 'list' : undefined"
    required
  >
    <template #append-inner v-if="!hideVisibilityToggle">
      <v-fade-transition hideOnLeave>
        <v-icon
          :icon="isPasswordVisible ? 'huge:view' : 'huge:view-off'"
          class="ic-16"
          @click="isPasswordVisible = !isPasswordVisible"
        />
      </v-fade-transition>
    </template>
  </v-text-field>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { usePasswordRules } from '@/composables/usePasswordRules';

interface Props {
  autocomplete?: string;
  counter?: number | boolean;
  hideVisibilityToggle?: boolean;
  id?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  rules?: any[];
}

withDefaults(defineProps<Props>(), {
  label: '',
  placeholder: '',
  rules: () => [],
  counter: false,
  hideVisibilityToggle: false
});

const { recommendPasswordRules } = usePasswordRules();

const passwordModel = defineModel();

const isPasswordVisible = ref(false);
</script>
